import React, { useEffect } from "react";
import { gsap } from "gsap";
import "./Hero.css";

export default function Hero() {
  useEffect(() => {
    gsap.fromTo(".hadeel-text",
      { opacity: 0, scale: 0.8, y: -50 },
      { duration: 1, opacity: 1, scale: 1, y: 0, ease: "power3.out" }
    );

    gsap.fromTo(".hero-sub",
      { opacity: 0, y: 30 },
      { duration: 1, delay: 0.5, opacity: 1, y: 0, ease: "power3.out" }
    );

    gsap.fromTo(".cta",
      { opacity: 0, y: 30 },
      { duration: 1, delay: 1, opacity: 1, y: 0, ease: "power3.out" }
    );
  }, []);

  const scrollToAbout = () => {
    const aboutSection = document.getElementById("about");
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero">
      <h1 className="hadeel-text">Hi, I'm Hadeel 👩‍💻</h1>
      <p className="hero-sub">Engineer. Storyteller. Gamer. Cat’s loyal servant.</p>
      <button className="cta" onClick={scrollToAbout}>
        Explore My World
      </button>
    </section>
  );
}
